import { axiosInstance } from './api';

/** GET /api/school-years/:personId/ */
export async function getSchoolYears(personId) {
  const response = await axiosInstance.get(`/school-years/${personId}/`);
  return response.data;
}

/** GET /api/activities/:personId/ */
export async function getActivities(personId) {
  const response = await axiosInstance.get(`/activities/${personId}/`);
  return response.data;
}

/** POST /api/activities/:personId/ */
export async function createActivity(personId, data) {
  const response = await axiosInstance.post(`/activities/${personId}/`, data);
  return response.data;
}

/** PATCH /api/update-grade/:personId/ */
export async function updateGrade(personId, data) {
  const response = await axiosInstance.patch(`/update-grade/${personId}/`, data);
  return response.data;
}

/** GET /api/child-stage-chapters/:personId/ */
export async function getChildStageChapters(personId) {
  const response = await axiosInstance.get(`/child-stage-chapters/${personId}/`);
  return response.data;
}
